import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import Loading from '../../common/components/loading';
import Header from './header.component';
import Footer from './footer.component';
import Content from './content.component';
import Sidebar from './sidebar.component';

class Home extends PureComponent {
  state = {
    isLoading: true,
  };

  async componentDidMount() {
    const { checkLoggedIn } = this.props;

    await checkLoggedIn();

    this.setState({
      isLoading: false,
    });
  }

  getRedirectUrl = () => {
    const { user } = this.props;

    switch (user.role) {
      case 0:
      case 1:
        return '/cars';
      case 2:
      default:
        return '/dashboard';
    }
  };

  render() {
    // const url = this.getRedirectUrl();
    const { isLoading } = this.state;
    const { isLogged } = this.props;

    if (isLoading) {
      return <Loading />;
    }

    if (!isLogged) {
      return <Redirect to="/login" />;
    }

    // if (isLogged && isAdmin) {
    //   return <Redirect to="/dashboard" />;
    // }

    // if (isLogged && !isAdmin) {
    //   return <Redirect to="/cars" />;
    // }

    return (
      <div className="c-app c-default-layout">
        <Sidebar />
        <div className="c-wrapper">
          <Header />

          <div className="c-body">
            <Content />
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

Home.propTypes = {
  checkLoggedIn: PropTypes.func.isRequired,
  isLogged: PropTypes.bool.isRequired,
  user: PropTypes.shape({ role: PropTypes.number }),
};

Home.defaultProps = {
  user: {},
};

export default Home;
